import { CPLAT_API_ROUTES, UploadSystem, usePost } from '@/api';
import { sellerQueries } from '@/api/seller-queries';
import ProfileIcon from '@/assets/icons/More/IconUserprofile.svg?react';
import SmallEditIcon from '@/assets/icons/SmallEditIcon.svg?react';
import { useToast } from '@/hooks/V3/useToast';
import { useAppSelector } from '@/redux/store';
import { CplatApiResponse } from '@/types/api';
import { useQueryClient } from '@tanstack/react-query';
import { ChangeEvent } from 'react';

interface Props {
  defaultImageUrl?: string;
}

const inputId = 'profile-img-upload';

export const ProfileImage = ({ defaultImageUrl }: Props) => {
  const queryClient = useQueryClient();

  const user = useAppSelector((state) => state.user);
  const cplatToken = user.CplatToken;

  const { showToast } = useToast();

  // getInfo는 파라미터 없이 정의
  const { mutate: onUpdateInfo } = usePost(CPLAT_API_ROUTES.updateInfo, undefined, undefined, true);

  const handleChangeImg = async (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    UploadSystem.uploadImgAsync(file).then(({ status, data }) => {
      if (status == 200) {
        const { data: cplatData } = data as CplatApiResponse<{ ImageUrl: string }[]>;
        const body = { cplatToken, sellerImageUrl: cplatData[0].ImageUrl };

        onUpdateInfo(body, {
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: sellerQueries.all() });
          },
        });
      } else {
        showToast('warning', '이미지 업로드 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
      }
    });
  };

  return (
    <div className="relative">
      {defaultImageUrl ? (
        <img src={defaultImageUrl} className="h-[120px] w-[120px] rounded-full " />
      ) : (
        <div className="flex h-[120px] w-[120px] items-center justify-center rounded-full bg-gr-50 ">
          <ProfileIcon className="h-[78px] w-[78px]" />
        </div>
      )}
      <label
        htmlFor={inputId}
        className="absolute bottom-0 right-0 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-gr-200 bg-white"
      >
        <SmallEditIcon width={24} height={24} />
        <input
          type="file"
          accept="image/*"
          onChange={handleChangeImg}
          style={{ display: 'none' }}
          id={inputId}
        />
      </label>
    </div>
  );
};
